import { CSSProperties, FC } from 'react';
import { SeparatorSlice } from '@/types';
import { useShowByLocationSlug } from '@/hooks';
import styles from './components.module.scss';
import classNames from 'classnames';

const ImageSeparator: FC<SeparatorSlice> = slice => {
  const { primary } = slice;

  const { showContent } = useShowByLocationSlug(primary?.location_slug);

  const svgBackground = primary?.pattern_image?.url ?? '';
  const backgroundColor = primary?.background_color ?? undefined;
  const backgroundSize = primary?.background_size ?? 'cover';
  const backgroundPosition = `left ${primary.background_position || 'center'}`;
  const offset = primary?.vertical_offset ?? 0;
  const rotation = primary?.image_rotation ?? 0;
  const overlap = primary?.overlap_adjacent;
  const sendToTheBack = primary?.send_to_the_back;
  const isVerticalOffset = overlap === 'next' || overlap === 'previous';

  const imageWidth = primary.pattern_image?.dimensions?.width;
  const imageHeight = primary.pattern_image?.dimensions?.height;

  // Ratio dynamic according to the Prismic image (SSR-safe, without window)
  const paddingTopPercent =
    imageWidth && imageHeight ? (imageHeight / imageWidth) * 100 : undefined;

  const topOffset = isVerticalOffset ? undefined : `${offset ?? 0}px`;

  if (!primary?.active || !showContent) {
    return null;
  }

  return (
    <section
      className={classNames(
        styles.separator,
        {
          ['spacing_bottom']:
            overlap === 'none' && slice?.primary?.margin_bottom,
        },
        overlap === 'previous' && styles.separator_overlap_previous,
        overlap === 'next' && styles.separator_overlap_next,
      )}
      style={
        {
          // Passing data to CSS for the formulas to live in SCSS
          ['--separator-padding-top']:
            paddingTopPercent !== undefined ? `${paddingTopPercent}%` : '0',
          ['--separator-bg-color']: backgroundColor ?? 'transparent',
          ['--separator-bg-image']: `url(${svgBackground})`,
          ['--separator-bg-size']: backgroundSize,
          ['--separator-bg-position']: backgroundPosition,
          ['--separator-top']: topOffset ?? '0px',
          ['--separator-offset']: `${offset}px`,
          ['--separator-rotation']: `${rotation}deg`,
          ['--separator-z-index']: sendToTheBack ? '0' : '3',
        } as CSSProperties
      }
    />
  );
};

export default ImageSeparator;
